/**
 * @typedef {(IDLE_BLACK | IDLE_WHITE | START)} TypeAction An action.
 */

/**
 * The 'IDLE_BLACK' action.
 * @type {'ACTION_IDLE_BLACK'}
 * @constant
 */
const IDLE_BLACK = 'ACTION_IDLE_BLACK';

/**
 * The 'IDLE_WHITE' action.
 * @type {'ACTION_IDLE_WHITE'}
 * @constant
 */
const IDLE_WHITE = 'ACTION_IDLE_WHITE';

/**
 * The 'START' action.
 * @type {'ACTION_START'}
 * @constant
 */
const START = 'ACTION_START';

export {

    IDLE_BLACK,
    IDLE_WHITE,
    START
};
